import type { destination } from './navigation';

export type Screen = ReturnType<typeof destination>;

export const SCREEN_TITLES: Record<Exclude<Screen, 'setup'>, string> = {
  waiting: 'Waiting',
  'turn-lobby': 'Room',
  'match-lobby': 'Match',
  competitive: 'Competitive',
  archive: 'Results',
  loading: 'Room',
  menu: 'Spellie',
  solo: 'Solo',
  versus: 'Versus',
  host: 'Host',
  join: 'Join',
  leaderboard: 'Leaderboard',
  settings: 'Settings',
  lobby: 'Lobby',
  game: 'Game',
  results: 'Results',
};
